// Worked examples for the Tech Debt Payback calculator. Illustrative: invented numbers.
// Addressable as #example=<id>.

export const EXAMPLES = [
  {
    id: "flaky-tests",
    name: "Flaky test suite",
    description: "Cheap to fix, costs a little every week. Illustrative.",
    state: { label: "Fix the flaky tests", principal: { low: 3, high: 8 }, interest: { low: 2, high: 6 }, recovered: { low: 60, high: 90 }, horizonMonths: 12, growthPct: 0, replacePct: 10 },
  },
  {
    id: "billing-module",
    name: "Tangled billing module",
    description: "Expensive, uncertain benefit, may be rewritten anyway. Illustrative.",
    state: { label: "Split the billing module", principal: { low: 15, high: 40 }, interest: { low: 1, high: 6 }, recovered: { low: 30, high: 80 }, horizonMonths: 18, growthPct: 20, replacePct: 25 },
  },
  {
    id: "agent-harness",
    name: "Test harness for coding agents",
    description: "Agents waste review time without it. Illustrative.",
    state: { label: "Test harness for the agents", principal: { low: 3, high: 6 }, interest: { low: 3, high: 10 }, recovered: { low: 40, high: 80 }, horizonMonths: 6, growthPct: 50, replacePct: 0 },
  },
];

export function exampleById(id) {
  return EXAMPLES.find((e) => e.id === id) ?? null;
}
